module.exports = __webpack_public_path__ + "assets/flag-bg.6f0d979314ef7329df32d3bde18b357d.svg";